import { useState, useMemo } from 'react'

export const useAsyncExtendedState = (initialState) => {
  const [state, setState] = useState(initialState)

  const asyncSetState = useMemo(
    () => async (nextState) => {
      const initialNextState = nextState

      try {
        if (nextState instanceof Promise) {
          nextState = await nextState

          if (nextState === initialNextState) {
            // there was an error but it was caught by something else - i.e., nextState.catch()
            throw new Error(`Uncatchable error.`)
          }
        }

        setState((state) => {
          if (typeof nextState === `function`) {
            nextState = nextState(state)
          }

          return nextState
        })
      } catch (error) {}
    },
    []
  )

  const asyncExtendState = useMemo(
    () => async (extendState) => {
      const initialExtendState = extendState

      try {
        if (extendState instanceof Promise) {
          extendState = await extendState

          if (extendState === initialExtendState) {
            // there was an error but it was caught by something else - i.e., extendState.catch()
            throw new Error(`Uncatchable error.`)
          }
        }

        setState((state) => {
          if (typeof extendState === `function`) {
            extendState = extendState(state)
          }

          return { ...state, ...extendState }
        })
      } catch (err) {}
    },
    []
  )

  return [state, asyncSetState, asyncExtendState]
}
